import { authenticationAction } from "_actions";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Container from "./Container";
import Navbar from "components/Navbar";
import FocusBlurHandler from "components/FocusBlurHandler";
import Emitter from "_actions/emitter";
import LoginModal from "components/Modals/LoginModal";
import { UserService } from "_services";
import MobileNavbar from "components/MobileNavbar";
import Blas975 from "components/Gamer/Blas975";
import socketServcies from "_services/GlobalSocket";
import { OAuth2Service } from "_services";
import UpdatePassword from "components/Modals/UpdatePassword";
import BalanceModal from "components/Modals/BalanceModal";
import BonusRequestModal from "components/Modals/BonusRequestModal";
import { checkTokenExpires } from "_services/httpOperations";
import toast from "react-hot-toast";
import i18n from "i18n";
import { Loader } from "rsuite";
import { SiteFeatures } from "config/siteFeatures";
const Dashboard = (props) => {
  const [isLogin, setIsLogin] = useState(false);
  const [isUpdatePass, setIsUpdatePass] = useState(false);
  const [isBalanceModal, setIsBalanceModal] = useState(false);
  const [balanceModalView, setBalanceModalView] = useState(null);
  const [isBonusRequestModal, setIsBonusRequestModal] = useState(false);
  const [myPermissions, setMyPermissions] = useState(false);
  const [loading, setLoading] = useState(true);
  const [bonus, setBonus] = useState(0);

  let ischeckTokenMultiLogin = true;
  const checkTokenMultiLogin = (status) => {
    let refresh_token = localStorage.getItem("refresh_token");
    OAuth2Service.REFRESH_TOKEN(refresh_token)
      .then((data) => {})
      .catch((err) => {
        Emitter.emit("LOGOUT", true);
        if (status && props.loggedIn && ischeckTokenMultiLogin) {
          ischeckTokenMultiLogin = false;
          toast(i18n.t("ALERT_LOGIN_SOMEBODY_OBSERVE"), {
            style: {
              borderRadius: "10px",
              color: "#B8860B",
              background: "#F9EF91",
            },
          });
        }
      });
  };

  const checkCustomTokenExpires = () => {
    checkTokenExpires(false)
      .then((data) => {
        // Token başarıyla kontrol edildi veya yenilendi
        // false dönerse token yok veya geçersiz, bu normal olabilir
        // true dönerse token geçerli veya yenilendi
        if (data === false) {
          // Token yok veya geçersiz - bu normal bir durum olabilir
          return;
        }
        // Token başarıyla kontrol edildi veya yenilendi
      })
      .catch((err) => {
        // Sadece gerçek token yenileme hatalarında işlem yap
        // OAuth2Service.REFRESH_TOKEN başarısız olduğunda buraya gelir
        console.error("Token yenileme hatası:", err);
        // Token yenileme başarısız olduğunda logout yap
        Emitter.emit("LOGOUT", true);
      });
  };

  const GET_AVAIABLE_SETTING = async () => {
    await UserService.GET_AVAIABLE_SETTING()
      .then((res) => {
        props.UpdatePermissions(res);
        setMyPermissions(true);
        setLoading(false);
      })
      .catch((err) => {
        debugger;
        setLoading(false);
      });
  };

  const handleIsLogin = (data) => {
    setIsLogin(data);
  };
  const checkToken = (status) => {
    const { LoginSuccess, LoginFailure } = props;
    UserService.USER_DETAIL()
      .then((res) => {
        LoginSuccess(res);
        GET_AVAIABLE_SETTING();
      })
      .catch((err) => {
        LoginFailure();

        //props.logout();
      });
  };

  useEffect(() => {
    if (props.loggedIn) {
      checkToken();
      socketServcies.initializeSocket();
      setIsLogin(false); // Giriş yapıldığında modal'ı kapat
       handleGetBonusWallet();
    } else {
      // Giriş yapılmamışsa LoginModal'ı kapalı tut (sadece gerektiğinde açılacak)
      setIsLogin(false);
    }
  }, [props.loggedIn]);

  useEffect(() => {
    Emitter.on("LOGIN_MODAL", (newValue) => {
      setIsLogin(newValue);
      if (newValue) {
        checkCustomTokenExpires();
      }
    });
    return () => {
      Emitter.off("LOGIN_MODAL");
    };
  }, []);

  useEffect(() => {
    Emitter.on("UPDATE_PASS", (newValue) => setIsUpdatePass(newValue));
    return () => {
      Emitter.off("UPDATE_PASS");
    };
  }, []);

  useEffect(() => {
    Emitter.on("BALANCE_MODAL", (newValue) => {
      setBalanceModalView(
        newValue === "deposit" || newValue === "withdraw" ? newValue : null,
      );
      setIsBalanceModal(!!newValue);
    });
    return () => {
      Emitter.off("BALANCE_MODAL");
    };
  }, []);

  useEffect(() => {
    Emitter.on("BONUS_REQUEST_MODAL", (newValue) => {
      setIsBonusRequestModal(!!newValue);
    });
    return () => {
      Emitter.off("BONUS_REQUEST_MODAL");
    };
  }, []);

  useEffect(() => {
    Emitter.on("REFRESH_WALLET", () => handleGetBonusWallet());
    return () => {
      Emitter.off("REFRESH_WALLET");
    };
  }, []);

  useEffect(() => {
    Emitter.on("LOGOUT", (newValue) => props.logout());
    return () => {
      Emitter.off("LOGOUT");
    };
  }, []);

  useEffect(() => {
    Emitter.on("new_balance", (newValue) => {
      props.updateWallet(newValue);
      handleGetBonusWallet();
    });
    return () => {
      Emitter.off("new_balance");
    };
  }, []);

  useEffect(() => {
    Emitter.on("CHECK_TOKEN", (status) => checkTokenMultiLogin(status));
    return () => {
      Emitter.off("CHECK_TOKEN");
    };
  }, []);

  const handleGetBonusWallet = () => {
    if (!SiteFeatures.BONUS_SYSTEM) return;
    UserService.GET_BONUS_BALANCE_DETAIL(props.user.RelUser._id)
      .then((res) => {
        setBonus(res.bonus);

        props.updateWallet(res);
        debugger;
      })
      .catch((err) => {
        debugger;
        try {
          if (err) {
          } else {
          }
        } catch (error) {}
      });
  };

  return (
    <>
      <>
        {/* Dashboard içeriği her zaman gösterilir (CLOSED_SYSTEM false ise) */}
        <Navbar />
        <MobileNavbar />
        {(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn) &&
          (!SiteFeatures.CLOSED_SYSTEM || myPermissions) && (
            <Container permissions={props.permissions} />
          )}

        {props.loggedIn && (!myPermissions || loading) && (
          <Loader className="z-[999]" backdrop center />
        )}

        {props.loggedIn && <FocusBlurHandler />}
      </>

      <LoginModal isActive={isLogin} />
      <UpdatePassword isActive={isUpdatePass} />
      {SiteFeatures.DEPOSIT_SYSTEM && (
        <BalanceModal isActive={isBalanceModal} initialView={balanceModalView} />
      )}
      {SiteFeatures.BONUS_SYSTEM && (
        <BonusRequestModal isActive={isBonusRequestModal} />
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn, permissions } = authentication;

  return {
    user,
    loggedIn,
    permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateUser: (user) => dispatch(authenticationAction.UpdateUser(user)),
    LoginSuccess: (user) => dispatch(authenticationAction.LoginSuccess(user)),
    LoginFailure: () => dispatch(authenticationAction.LoginFailure()),
    logout: () => dispatch(authenticationAction.logout()),
    updateWallet: (data) => dispatch(authenticationAction.UpdateWallet(data)),
    UpdatePermissions: (data) =>
      dispatch(authenticationAction.UpdatePermissions(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
